import { Component, OnInit, Input } from '@angular/core';
import { MainComponent } from 'src/app/main/main.component';

@Component({
  selector: 'new-notification',
  templateUrl: './new-notification.component.html'
})
export class NewNotificationComponent implements OnInit {
  @Input() newNotification: any;

  interval: any;
  constructor(
    private main: MainComponent
  ) { }

  ngOnInit() {
    this.interval = setInterval(()=> { this.closeNewNotification(this.newNotification.id); clearInterval(this.interval) }, 5000)
  }

  closeNewNotification(id){
    this.main.closeNotificationBanner(id)
  }
}
